import { URL_DOWNLOAD, URL_MIDIS, URLAPI } from "../../Setting";
import axios from "axios";
import { errorService } from "../Error/ErrorService";
import { DemandeService } from "./DemandeService";
import { Fichier } from "../../Models/Demande/DemandeModels";

export function FichierService(){

    function supprimerUpload(nomFichier: string): string {
        const indexDernierSlash = nomFichier.lastIndexOf('/');
        if (indexDernierSlash === -1) {
            // Pas d'extension trouvée
            return nomFichier;
        }
        return nomFichier.substring(indexDernierSlash+1, nomFichier.length);
    }

    return{
        async deleteFichier(idFichier:number, token:string){

            // try {
                const responsePOSTFichier = await axios.delete(
                    `${URLAPI+'fichier/'+idFichier}`, 
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            // "Content-Type": `multipart/form-data`,
                        },
                        // transformRequest: () => { return fichier}
                    }
                );

                return responsePOSTFichier.status;
            // } catch (error) {
            //     errorService().handleError("Erreur dans la suppression du fichier", error);
            //     return 400;
            // }
        },

        async postFichierDemande(fichier:File, idDemande:number, token:string){

            try {
                const formData = new FormData();
                formData.append('nom', fichier.name);
                formData.append('fichier', fichier); // ou le nom attendu par l’API
                formData.append('demande', idDemande.toString());

                const responsePOSTFichier = await axios.post(
                    `${URLAPI+'fichier'}`, 
                    formData, 
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            // "Content-Type": `multipart/form-data`,
                        },
                        // transformRequest: () => { return fichier}
                    }
                );

                return {id:responsePOSTFichier.data['id'], status:responsePOSTFichier.status};
            } catch (error) {
                await DemandeService().deleteDemande(idDemande, token);
                errorService().handleError("Erreur dans l'envoi du fichier", error);
                return {id:0, status:400};
            }
        },

        async postFichier(fichier:File, token:string){
            const formData = new FormData();
            formData.append('nom', fichier.name);
            formData.append('fichier', fichier); // ou le nom attendu par l’API


            const responsePOSTFichier = await axios.post(
                `${URLAPI+'fichier'}`, 
                formData, 
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        // "Content-Type": "multipart/form-data",
                    },
                    // transformRequest: () => { return postFichierObjet}
                }
            );

            return {status:responsePOSTFichier.status, id:responsePOSTFichier.data['id']};
            // return 200;
        },

        async postFichierStyle(fichier:File, idStyle:number, token:string){
            const formData = new FormData();
            formData.append('nom', fichier.name);
            formData.append('fichier', fichier); // ou le nom attendu par l’API
            formData.append('style', idStyle.toString());


            const responsePOSTFichier = await axios.post(
                `${URLAPI+'fichier'}`, 
                formData, 
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        // "Content-Type": "multipart/form-data",
                    },
                    // transformRequest: () => { return postFichierObjet}
                }
            );

            return {status:responsePOSTFichier.status, id:responsePOSTFichier.data['id']};
            // return 200;
        },

        async postFichierEnseigne(fichier:File, idEnseigne:number, token:string){
            const formData = new FormData();
            formData.append('nom', fichier.name);
            formData.append('fichier', fichier); // ou le nom attendu par l’API
            formData.append('enseigne', idEnseigne.toString());


            const responsePOSTFichier = await axios.post(
                `${URLAPI+'fichier'}`, 
                formData, 
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        // "Content-Type": "multipart/form-data",
                    },
                    // transformRequest: () => { return postFichierObjet}
                }
            );

            return {status:responsePOSTFichier.status, id:responsePOSTFichier.data['id']};
            // return 200;
        },

        async postFichierMessage(fichier:File, idMessage:number, token:string){
            const formData = new FormData();
            formData.append('nom', fichier.name);
            formData.append('fichier', fichier); // ou le nom attendu par l’API
            formData.append('message', idMessage.toString());


            const responsePOSTFichier = await axios.post(
                `${URLAPI+'fichier'}`, 
                formData, 
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        // "Content-Type": "multipart/form-data",
                    },
                    // transformRequest: () => { return postFichierObjet}
                }
            );

            return {status:responsePOSTFichier.status, id:responsePOSTFichier.data['id']};
            // return 200;
        },

        async postFichierMarketing(fichier:File, idMarketing:number, token:string){
            const formData = new FormData();
            formData.append('nom', fichier.name);
            formData.append('fichier', fichier); // ou le nom attendu par l’API
            formData.append('marketing', idMarketing.toString());

            const responsePOSTFichier = await axios.post(
                `${URLAPI+'fichier'}`, 
                formData, 
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        // "Content-Type": "multipart/form-data",
                    },
                    // transformRequest: () => { return postFichierObjet}
                }
            );

            return {status:responsePOSTFichier.status, id:responsePOSTFichier.data['id']};

        },

        async postFichierTypeMagasin(fichier:File, idType:number, token:string){
            const formData = new FormData();
            formData.append('nom', fichier.name);
            formData.append('fichier', fichier); // ou le nom attendu par l’API
            formData.append('typeMagasin', idType.toString());


            const responsePOSTFichier = await axios.post(
                `${URLAPI+'fichier'}`, 
                formData, 
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        // "Content-Type": "multipart/form-data",
                    },
                    // transformRequest: () => { return postFichierObjet}
                }
            );

            return {status:responsePOSTFichier.status, id:responsePOSTFichier.data['id']};
            // return 200;
        },

        async downloadFichierViaID(idFichier:number, token:string){
            try {
                const reponseGet = await axios.get(
                    `${URLAPI+'fichier/'+idFichier}`, 
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/ld+json",
                        },
                    }
                );

                if(reponseGet.data.length>0){
                    const cheminFichier = reponseGet.data[0].chemin;
                    const nomFichier = reponseGet.data[0].nom;

                    await axios.get(
                        `${URL_DOWNLOAD+cheminFichier}`, 
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                            responseType:'blob',
                            // onDownloadProgress:(progress)=>{
                            //     console.log(progress)
                            // }
                        }
                    ).then((obj)=>{
                        const url = URL.createObjectURL(obj.data);
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = nomFichier;
                        a.style.display = 'none';
                        document.body.appendChild(a);
                        a.click()
                        a.remove()
                        URL.revokeObjectURL(url);
                    });
                }
            } catch (error) {
                return;
            }
        },

        async downloadFichierNom(nomFichier:string, token:string){
            try {
                const reponseGet = await axios.get(
                    `${URLAPI+'fichier/nom/'+nomFichier}`, 
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/ld+json",
                        },
                    }
                );

                if(reponseGet.data.length>0){
                    const cheminFichier = reponseGet.data[0].chemin;

                    await axios.get(
                        `${URL_DOWNLOAD+cheminFichier}`, 
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                            responseType:'blob',
                            // onDownloadProgress:(progress)=>{
                            //     console.log(progress)
                            // }
                        }
                    ).then((obj)=>{
                        const url = URL.createObjectURL(obj.data);
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = nomFichier;
                        a.style.display = 'none';
                        document.body.appendChild(a);
                        a.click()
                        a.remove()
                        URL.revokeObjectURL(url);
                    });
                }
            } catch (error) {
                return;
            }
        },

         async downloadFichierViaChemin(cheminFichier:string, nomFichier:string, token:string){
            try {
                if(/^\s*$/.test(cheminFichier) || /^\s*$/.test(nomFichier)) return;

                const response = await axios.get(
                    `${URL_DOWNLOAD+cheminFichier}`, 
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Access-Control-Allow-Origin' : '*',
                        },
                        responseType:'blob',
                        // onDownloadProgress:(progress)=>{
                        //     console.log(progress)
                        // }
                    }
                );

                const url = URL.createObjectURL(new Blob([response.data]));
                const a = document.createElement('a');
                a.href = url;
                a.setAttribute('download', nomFichier);
                // a.style.display = 'none';
                document.body.appendChild(a);
                a.click()
                a.remove()
                URL.revokeObjectURL(url);
            } catch (error) {
                return;
            }
        },

        async getFichierObjetViaURL(url:string|undefined, token:string){
            if(!url)throw new Error('URL Fichier non obtenu');
            let fichier:Fichier = {id:0, chemin:'', nom:''};
            try {
                const reponseGet = await axios.get(
                    `${URL_MIDIS+url}`, 
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/ld+json",
                        },
                    }
                );
                const data = reponseGet.data['hydra:member'];
                if(data.length>0){
                    fichier = {
                        id:data[0]['id'],
                        nom:data[0]['nom'],
                        chemin:data[0]['chemin']
                    }
                }
            } catch (error) {
                errorService().handleError('Erreur obtention fichier', error);
                return;
            }
            return fichier;
        },

        async getFichierObjetViaID(id:number, token:string){
            let fichier:Fichier = {id:0, chemin:'', nom:''};
            try {
                const reponseGet = await axios.get(
                    `${URLAPI+'fichier/'+id}`, 
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/ld+json",
                        },
                    }
                );
                const data = reponseGet.data['hydra:member'];
                if(data.length>0){
                    fichier = {
                        id:data[0]['id'],
                        nom:data[0]['nom'],
                        chemin:data[0]['chemin']
                    }
                }
            } catch (error) {
                errorService().handleError('Erreur obtention fichier', error);
                return;
            }
            return fichier;
        } 
    }
}